/**
 * Tag variant mapping for event tags
 */
const TAG_VARIANTS: Record<
  string,
  "default" | "success" | "warning" | "error" | "info"
> = {
  Open: "success",
  Racing: "info",
  Training: "warning",
  Junior: "default",
  RYA: "error",
  Social: "default",
  Beginner: "info",
  Advanced: "warning",
};

/**
 * Gets the variant for a tag name, defaulting to "default" if not found
 */
export function getTagVariant(tagName: string): "default" | "success" | "warning" | "error" | "info" {
  return TAG_VARIANTS[tagName] || "default";
}

